import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { fetch, setValidacoes } from "../actions/index";
import { InputPadrao, LabelPadrao, LoadingContainerPadrao, ModalPadrao } from "../components/Base";
import { BtnPadrao, BtnSair } from "../components/Buttons";
import Mensagens from "../components/Mensagens";
import { Radio, Select } from "antd";

function ModalValidacoes({ ...props }) {
    const [loading, setLoading] = useState(false);
    const [validacoes, setValidacoes] = useState(props?.validacao);
    const validacao = props?.validacao;
    const errorMsg = "Validações não confirmadas";

    useEffect(() => setValidacoes(validacao?.validacoes?.length ? validacao?.validacoes : []), [validacao?.validacoes?.length]);

    const handleReject = rejectRet => {
        validacao.req.reject(rejectRet || { response: { status: 400, data: errorMsg } });
        props.setValidacoes(null);
        setLoading(false);
    };

    const onOk = () => {
        const { url, dados, resolve } = validacao.req;

        setLoading(true);
        props.fetch().post(url, dados, { headers: { ...validacao.headers, validacoesConfirmadas: btoa(JSON.stringify(validacoes)) } }).then(s => {
            resolve(s);
            setLoading(false);
            props.setValidacoes(null);
        }).catch(error => {
            setLoading(false);
            const data = error?.response?.data;

            if (error?.response?.status == 503) {
                if (data.isValidacao) {
                    Mensagens.showErro("Confirme as novas operações");
                    return setValidacoes(data.validacoes.map(x => ({ ...x, valorRet: x.valor })));
                }
                else
                    return handleReject(error);
            }

            let msg = (error?.response?.status === 400 || data?.isAuditoria) && !!data ? data : "Falha na conexão";
            if (!!msg)
                Mensagens.showErro(msg);
        });
    };

    const zIndex = 50000;

    return <ModalPadrao closable={false} width={500} title="Deseja realizar estas operações?" visible={!!validacao} zIndex={zIndex} footer={<>
        <BtnPadrao type="primary" onClick={() => onOk(false)} disabled={loading || validacoes?.find(x => !!x.tipo && !x.valor)}>Confirmar</BtnPadrao>
        <BtnSair disabled={loading} onClick={() => handleReject()} />
    </>}>
        <LoadingContainerPadrao loading={loading} style={{ minHeight: 300 }}>
            {validacoes?.map(x => <div style={{ borderBottom: "1px solid #ddd", marginTop: 5, paddingBottom: 5, display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                <div key={x.id}>
                    <LabelPadrao >{x.detalhe.titulo}</LabelPadrao>
                    {x.detalhe.descricoes.map(s => <p style={{ maxWidth: 450 }} key={s}>{s}</p>)}
                </div>

                {x.tipo === "Bool" &&
                    <Radio.Group value={x?.valor} onChange={v => {
                        const aux = [...validacoes];
                        var item = aux.find(s => s.id == x.id);
                        item.valor = v.target.value;
                        setValidacoes(aux);
                    }} disabled={!!x.valorRet}>
                        <Radio value="true">Sim</Radio>
                        <Radio value="false">Não</Radio>
                    </Radio.Group>}
                {x.tipo === "Combo" && <>
                    <Select style={{ width: 180 }} dropdownStyle={{ zIndex: zIndex }} placeholder="informe o valor" value={x.valor} onChange={v => {
                        const aux = [...validacoes];
                        var item = aux.find(s => s.id == x.id);
                        item.valor = v;
                        setValidacoes(aux);
                    }} disabled={!!x.valorRet}>
                        {x.valoresPossiveis?.map(s => <Select.Option key={s}>{s}</Select.Option>)}
                    </Select>
                </>}
                {x.tipo === "String" && <InputPadrao placeholder="informe o valor" style={{ maxWidth: 180 }} value={x.valor} onChange={v => {
                    const aux = [...validacoes];
                    var item = aux.find(s => s.id == x.id);
                    item.valor = v.target.value;
                    setValidacoes(aux);
                }} disabled={!!x.valorRet} />}
            </div>)}
        </LoadingContainerPadrao>
    </ModalPadrao>;
}

const mapStateToProps = state => ({ validacao: state.validacao });

export default connect(mapStateToProps, { setValidacoes, fetch })(ModalValidacoes);